import { APP_INIT_FAILURE, APP_INIT_START, APP_INIT_SUCCESS } from "./appConstants";
import createAction from "./createAction";

export const appInitAction = (payload) => createAction(APP_INIT_START, payload);
export const appInitSuccess = (payload) => createAction(APP_INIT_SUCCESS, payload);
export const appInitFailure = (payload) => createAction(APP_INIT_FAILURE, payload);
